import { Box, Button, Divider, Input, Sheet, Typography } from "@mui/joy";
import { useContractorIDs } from "../../routes/contractor";
import { useContractor } from "../../redux/contractor/contractorHooks";
import { useDispatch } from "react-redux";
import { setFormOpen, setSelectedContractorIDs } from "../../reducers/rhapsody";
import { useSeasons } from "../../redux/season/seasonHooks";
import { OrganizationCustomFields } from "../customFields/customFieldsSection";

/**
 *
 * @returns {ReactElement} ContractorGeneral page
 */
export function ContractorGeneral() {
  const contractorIDs = useContractorIDs();
  const { contractor, isLoading } = useContractor(contractorIDs);
  const { seasons } = useSeasons();
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        maxWidth: 600,
        width: "100%",
        flexDirection: "column",
        gap: 1,
        display: "flex",
        alignItems: "stretch",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {contractor.sourceID === 420 ? (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Button
            onClick={() => {
              dispatch(setSelectedContractorIDs(contractorIDs));
              dispatch(setFormOpen({ isOpen: true, formID: "contractor" }));
            }}
            variant="soft"
            color="neutral"
            startDecorator={<i className="fa-solid fa-pen"></i>}
          >
            Edit
          </Button>
        </Box>
      ) : (
        <></>
      )}
      <Box>
        <Typography level="body3">ABOUT THE CONTRACTOR</Typography>
        <Sheet variant="soft" sx={{ borderRadius: 8 }}>
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"ID:"}
            value={contractor?.id}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Name:"}
            value={contractor?.name}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Description:"}
            value={contractor?.description}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Contact:"}
            value={contractor?.contact}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Email:"}
            value={contractor?.email}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Phone:"}
            value={contractor?.phone}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"City:"}
            value={contractor?.city}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"Zipcode:"}
            value={contractor?.zipcode}
          />
          <Divider />
          <Input
            readOnly
            slotProps={{ input: { style: { textAlign: "right" } } }}
            variant="soft"
            startDecorator={"State:"}
            value={contractor?.state}
          />
        </Sheet>
      </Box>
      {/* Custom fields this organization asks the musician to fill in */}
      <OrganizationCustomFields organizationID={contractor?.organizationID} />
    </Box>
  );
}
